import React, { useMemo } from 'react'
import { Dropdown, Form } from 'semantic-ui-react'

import { TooltipLabel } from 'components/TooltipLabel'
import { BENCHMARK_HELP_URL } from 'components/BenchmarkInfoContent'

const INDUSTRY_DESCRIPTION =
  'Choose the industry used for benchmark comparisons on your dashboards. This is set from your onboarding answers and can be changed any time.'

const NO_INDUSTRY_OPTIONS = []
const INDUSTRY_INPUT_ID = 'workspace-benchmark-industry'

const IndustryInfoContent = () => (
  <React.Fragment>
    <p>
      Your industry is used to compare your CSAT and NPS with similar companies using
      Simplesat&apos;s benchmark data.
    </p>
    <p>You can change the industry for this workspace.</p>
    <p>If your industry has limited data, the all-industry benchmark is shown.</p>
  </React.Fragment>
)

export default function WorkspaceBenchmarkSettings({
  selectedIndustry,
  industryOptions = NO_INDUSTRY_OPTIONS,
  industryLoading,
  handleChangeIndustry,
  disabled,
}) {
  const dropdownOptions = useMemo(
    () =>
      industryOptions.map((option) => ({
        key: option.industry,
        value: option.industry,
        text: option.label,
      })),
    [industryOptions]
  )

  return (
    <React.Fragment>
      <h3 className="flex items-center ui header">
        Benchmarks
        <TooltipLabel
          descriptionTitle="Benchmarks"
          descriptionContentWithFormat={<IndustryInfoContent />}
          learnMoreLink={BENCHMARK_HELP_URL}
        />
      </h3>
      <p>{INDUSTRY_DESCRIPTION}</p>

      <Form.Field>
        <label htmlFor={INDUSTRY_INPUT_ID}>Industry</label>
        <Dropdown
          value={selectedIndustry}
          options={dropdownOptions}
          selection
          fluid
          search
          searchInput={{ id: INDUSTRY_INPUT_ID }}
          placeholder="Select industry"
          loading={industryLoading}
          onChange={handleChangeIndustry}
          disabled={disabled}
        />
      </Form.Field>
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/components/WorkspaceBenchmarkSettings/index.js